import { render, staticRenderFns } from "./EntityAccountList.vue?vue&type=template&id=b22e97e2&scoped=true&"
import script from "./EntityAccountList.vue?vue&type=script&lang=js&"
export * from "./EntityAccountList.vue?vue&type=script&lang=js&"
import style0 from "./EntityAccountList.vue?vue&type=style&index=0&id=b22e97e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22e97e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b22e97e2')) {
      api.createRecord('b22e97e2', component.options)
    } else {
      api.reload('b22e97e2', component.options)
    }
    module.hot.accept("./EntityAccountList.vue?vue&type=template&id=b22e97e2&scoped=true&", function () {
      api.rerender('b22e97e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/entityAccount/EntityAccountList.vue"
export default component.exports